import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { Emitter, LinkedListContainer } from "@pixi/particle-emitter";
import { GameTestEvent } from "../../../controller/event/GameEvent";
export class GameReelWildParticles extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        Logger.addObjectRef(this);
        const emitterContainer = new LinkedListContainer();
        this.emitter = new Emitter(this.addChild(emitterContainer), this.landscapeProperties.emitterProperties);
        this.emitter.emit = false;
        this.registerGame(SlingoEvent.DAB_ACTIVE, this.updateParticles);
        this.registerGame(SlingoEvent.DAB_SUCCESS, this.handleDabComplete);
        this.registerGame(GameTestEvent.TRIGGER_WILD_PARTICLES, () => this.emitter.emit = true);
    }
    updateParticles() {
        const ticketDab = this.model.getDabData();
        this.emitter.emit = ticketDab.getSuperJokerCells().length > 0 || ticketDab.getJokerCells().length > 0;
    }
    handleDabComplete() {
        const reelSequence = this.model.getSpinResult().getReelSequence();
        const undabbedJokers = reelSequence.getJokerIndexes();
        const undabbedSuperJokers = reelSequence.getSuperJokerIndexes();
        if (undabbedJokers.length || undabbedSuperJokers.length)
            return;
        this.emitter.emit = false;
    }
}
//# sourceMappingURL=GameReelWildParticles.js.map